import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  FINANCE_LIST_QUERY_KEY,
  FINANCE_PERMISSIONS,
} from '@modules/finance/constants';
import { isString } from '@utils/guards';

import type { IFinanceMonthChangeStatusPayload } from '../types';
import {
  FINANCE_MONTH_LIST_QUERY_KEY,
  FINANCE_MONTH_PROCESS_MUTATION_KEY,
  FINANCE_MONTH_PROCESS_URL,
} from '../constants';

export default function useProcessFinanceMonthMutation(): IContextMutationResult<
  void,
  Error,
  IFinanceMonthChangeStatusPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IFinanceMonthChangeStatusPayload>({
    mutationKey: [FINANCE_MONTH_PROCESS_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      FINANCE_MONTH_PROCESS_URL,
      payload,
      { permission: FINANCE_PERMISSIONS.CHANGE_STATUS },
    ),
    onSuccess({ queryClient }) {
      void queryClient.invalidateQueries({
        predicate: (query) => isString(query.queryKey[0]) && [
          FINANCE_MONTH_LIST_QUERY_KEY,
          FINANCE_LIST_QUERY_KEY,
        ].includes(query.queryKey[0]),
      });
    },
  });
}
